export enum Frequency {
    Immediate = 1,
    Weekly = 7,
    Monthly = 30
}
